/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { useIdentityGatewayServiceStore } from 'dxpConsoleCore-mf/State';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { lastValueFrom } from 'rxjs';
import { ERROR_SCREEN_TYPES } from '../../Screens/DxpErrorScreen/DxpErrorScreen.constants';
import { LoadingScreen } from '../../Screens/LoadingScreen/LoadingScreen';
import { getConsoleService } from '../../Services/console';
import { getIdentityGatewayService } from '../../Services/identity-gateway';
import { getServiceTokens } from '../../Utilities/GetServiceTokens/GetServiceTokens';

/**
 * Upon successful IdP authentication, the user will redirect to the /idp-authorize route.
 * The redirect url will contain an authorization code to create a session in the DXP.
 * If a session cannot be created, the user will redirect to /error.
 */
export const IdpLoginAuthorize = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();

  const consoleService = getConsoleService();
  const identityGatewayService = getIdentityGatewayService();
  const { updateHasSession } = useIdentityGatewayServiceStore();

  const idpSessionCode = new URLSearchParams(location.search).get(`code`) as string;

  useEffect(() => {
    if (consoleService && idpSessionCode) {
      lastValueFrom(consoleService.logInWithIdpSession(idpSessionCode))
        .then(async () => {
          updateHasSession(true);
          await getServiceTokens();

          // Navigate to IdP SSO service to continue
          const ssoCallbackUrl = identityGatewayService.createSsoCallbackUrl();
          window.location.assign(`${ssoCallbackUrl}?code=${idpSessionCode}`);

          return true;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);

          navigate({
            pathname: `/error`,
            search: `?type=${ERROR_SCREEN_TYPES.idpError}`,
          });

          return true;
        });
    }
  }, [consoleService, identityGatewayService, idpSessionCode, navigate, updateHasSession]);

  return <LoadingScreen />;
};
